import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import { useAppDispatch, useAppSelector } from "app/store";
import { closeToast, selectStateToast } from "app/store/trackingApp/toastSlice";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const Toast: React.FC = () => {
  const { open, content } = useAppSelector(selectStateToast);
  const dispatch = useAppDispatch();
  const { severity, title } = content;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={2000}
        onClose={() => dispatch(closeToast())}
      >
        <Alert variant="filled" severity={severity ?? "info"}>
          {title}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Toast;
